import SimpleDialog, { SimpleDialogProps } from '@/libs/material/simple-dialog';
import { SimpleDialogBackground } from '@/libs/material/simple-dialog/types';
import { SNOWFLAKE_DARK_URL, SNOWFLAKE_LIGHT_URL } from '@/utils/constants';
import { DS_WIDTH } from '@calm/evexia-design-tokens';
import { Box, SxProps, Theme } from '@rhg/libs/material';
import { ReactNode } from 'react';

const styleContentContainer = {
    position: 'relative',
};
const styleButtonContainer = {
    my: 2,
    width: '100%',
    maxWidth: DS_WIDTH.FORM_MAX_WIDTH,
};
const styleButtonWrapper = {
    alignItems: 'center',
};
const styleContentWrapper = { mt: 2, zIndex: 1 };
const styleBackgroundImage = {
    '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: (theme: Theme) =>
            `url(${
                theme.palette.mode === 'light'
                    ? SNOWFLAKE_LIGHT_URL
                    : SNOWFLAKE_DARK_URL
            })`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: 0,
    },
};

export type RewardsDialogBaseProps = SimpleDialogProps & {
    isOpen: boolean;
    onClose: () => void;
    dialogContent: ReactNode;
    dialogButton?: ReactNode;
    actionsHeader?: ReactNode;
    contentSx?: SxProps<Theme>;
};

const RewardsDialogBase = ({
    isOpen,
    onClose,
    dialogContent,
    dialogButton,
    actionsHeader,
    ...props
}: RewardsDialogBaseProps) => {
    return (
        <SimpleDialog
            fullScreen
            isOpen={isOpen}
            onClose={onClose}
            background={SimpleDialogBackground.Content}
            sx={styleContentContainer}
            contentContainerStyle={styleBackgroundImage}
            {...(dialogButton
                ? {
                      buttons: [
                          {
                              // React 19: rawComponent needs a key when rendered in a list/map
                              rawComponent: (
                                  <Box
                                      key="dialog-button"
                                      sx={styleButtonContainer}
                                  >
                                      {dialogButton}
                                  </Box>
                              ),
                          },
                      ],
                      buttonsContainerStyle: styleButtonWrapper,
                  }
                : {})}
            content={
                <>
                    {actionsHeader ?? null}
                    <Box sx={styleContentWrapper}>{dialogContent}</Box>
                </>
            }
            {...props}
        />
    );
};

export default RewardsDialogBase;
